export default {
  TOGGLE_NAV: 'TOGGLE_NAV',
  ROUTE_CHANGED: 'ROUTE_CHANGED',
  ROUTE_PARAMS: 'ROUTE_PARAMS',
}
